import React from "reactn";
import { app } from "js/namespaces.js";
import { calcEaseInOut } from "js/core/utilities/utilities";
import { $, _, WordCloud, SVG } from "js/vendor";
import * as geom from "js/core/utilities/geom";
import { BaseElement } from "js/elements/base/BaseElement";
import { ForeColorType, BackgroundStyleType } from "common/constants";
import { getCSSTransform } from "js/core/utilities/geom";
import { SVGGroup } from "js/core/utilities/svgHelpers";
import Spinner from "js/react/components/Spinner";
import { isRenderer } from "js/config";

class WordCloudElement extends BaseElement {
    static get schema() {
        return {
            style: "right_angles",
            sort: "size",
            scale: 25,
            calculatedWidth: 1180,
            calculatedHeight: 620,
            version: 2,
            wordcloud: "[{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1486,\"y\":790,\"rotation\":0,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":1054,\"y\":874,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":1402,\"y\":842,\"rotation\":0,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":866,\"y\":778,\"rotation\":0,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":792,\"y\":540,\"rotation\":90,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1056,\"y\":366,\"rotation\":0,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1312,\"y\":366,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":1414,\"y\":426,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":1556,\"y\":526,\"rotation\":0,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":1332,\"y\":862,\"rotation\":0,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1346,\"y\":386,\"rotation\":0,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":796,\"y\":696,\"rotation\":90,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1492,\"y\":766,\"rotation\":0,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1234,\"y\":870,\"rotation\":0,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":1498,\"y\":466,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":984,\"y\":838,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":874,\"y\":468,\"rotation\":-90,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":1536,\"y\":728,\"rotation\":90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1506,\"y\":486,\"rotation\":0,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":910,\"y\":434,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":1406,\"y\":822,\"rotation\":0,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":898,\"y\":790,\"rotation\":90,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":1140,\"y\":870,\"rotation\":0,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1566,\"y\":620,\"rotation\":-90,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1128,\"y\":366,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":878,\"y\":758,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":792,\"y\":620,\"rotation\":-90,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":1216,\"y\":366,\"rotation\":0,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1294,\"y\":386,\"rotation\":0,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":1324,\"y\":842,\"rotation\":0,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1382,\"y\":412,\"rotation\":90,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1446,\"y\":446,\"rotation\":90,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":978,\"y\":818,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":1516,\"y\":642,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":1350,\"y\":532,\"rotation\":-90,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":820,\"y\":700,\"rotation\":90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1510,\"y\":718,\"rotation\":90,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":1518,\"y\":594,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":924,\"y\":802,\"rotation\":90,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":1258,\"y\":554,\"rotation\":90,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":992,\"y\":426,\"rotation\":0,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1490,\"y\":724,\"rotation\":-90,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1324,\"y\":822,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":1310,\"y\":734,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":988,\"y\":798,\"rotation\":0,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":844,\"y\":712,\"rotation\":90,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1470,\"y\":718,\"rotation\":-90,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":1512,\"y\":618,\"rotation\":0,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1012,\"y\":446,\"rotation\":0,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1006,\"y\":466,\"rotation\":0,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":1442,\"y\":486,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":1372,\"y\":494,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":1272,\"y\":734,\"rotation\":0,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":1128,\"y\":612,\"rotation\":-90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"2\",\"layout\":{\"x\":822,\"y\":536,\"rotation\":90,\"offsetX\":-69.4749755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"2\",\"layout\":{\"x\":1024,\"y\":396,\"rotation\":0,\"offsetX\":-92.39996337890625,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"2\",\"layout\":{\"x\":1320,\"y\":416,\"rotation\":0,\"offsetX\":-49.449974060058594,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"2\",\"layout\":{\"x\":1396,\"y\":792,\"rotation\":0,\"offsetX\":-68.07496643066406,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"2\",\"layout\":{\"x\":876,\"y\":704,\"rotation\":-90,\"offsetX\":-44.324981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"2\",\"layout\":{\"x\":864,\"y\":548,\"rotation\":-90,\"offsetX\":-56.72498321533203,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"2\",\"layout\":{\"x\":1186,\"y\":396,\"rotation\":0,\"offsetX\":-71.27497100830078,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"2\",\"layout\":{\"x\":1462,\"y\":516,\"rotation\":0,\"offsetX\":-58.074981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"2\",\"layout\":{\"x\":1440,\"y\":726,\"rotation\":-90,\"offsetX\":-34.74999237060547,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"2\",\"layout\":{\"x\":1496,\"y\":672,\"rotation\":0,\"offsetX\":-68.5999755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"2\",\"layout\":{\"x\":916,\"y\":714,\"rotation\":-90,\"offsetX\":-47.824981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"2\",\"layout\":{\"x\":906,\"y\":532,\"rotation\":-90,\"offsetX\":-73.17498016357422,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"2\",\"layout\":{\"x\":1486,\"y\":556,\"rotation\":0,\"offsetX\":-79.87496948242188,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"2\",\"layout\":{\"x\":1366,\"y\":752,\"rotation\":0,\"offsetX\":-38.449981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"2\",\"layout\":{\"x\":1348,\"y\":456,\"rotation\":0,\"offsetX\":-84.97496032714844,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"2\",\"layout\":{\"x\":956,\"y\":728,\"rotation\":-90,\"offsetX\":-60.8499755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"2\",\"layout\":{\"x\":946,\"y\":524,\"rotation\":-90,\"offsetX\":-76.84996795654297,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"2\",\"layout\":{\"x\":1384,\"y\":540,\"rotation\":-90,\"offsetX\":-33.42498779296875,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"colors\",\"weight\":\"3\",\"layout\":{\"x\":890,\"y\":634,\"rotation\":0,\"offsetX\":-85.98748016357422,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"strategies\",\"weight\":\"3\",\"layout\":{\"x\":1150,\"y\":834,\"rotation\":0,\"offsetX\":-133.01246643066406,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"diversity\",\"weight\":\"3\",\"layout\":{\"x\":1152,\"y\":446,\"rotation\":0,\"offsetX\":-115.7249755859375,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"disruptive\",\"weight\":\"3\",\"layout\":{\"x\":1198,\"y\":774,\"rotation\":0,\"offsetX\":-129.93746948242188,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"layout\",\"weight\":\"3\",\"layout\":{\"x\":1344,\"y\":698,\"rotation\":0,\"offsetX\":-83.54998016357422,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"work\",\"weight\":\"4\",\"layout\":{\"x\":1394,\"y\":614,\"rotation\":0,\"offsetX\":-88.74998474121094,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"smart\",\"weight\":\"4\",\"layout\":{\"x\":1156,\"y\":706,\"rotation\":0,\"offsetX\":-103.99998474121094,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"simple\",\"weight\":\"4\",\"layout\":{\"x\":1014,\"y\":678,\"rotation\":-90,\"offsetX\":-109.44998168945312,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"Beautiful\",\"weight\":\"5\",\"layout\":{\"x\":1162,\"y\":524,\"rotation\":0,\"offsetX\":-200.375,\"offsetY\":12.5,\"fontSize\":125,\"weight\":\"5\"},\"drawn\":true},{\"word\":\"Slides\",\"weight\":\"5\",\"layout\":{\"x\":1178,\"y\":620,\"rotation\":0,\"offsetX\":-128.3125,\"offsetY\":12.5,\"fontSize\":125,\"weight\":\"5\"},\"drawn\":true}]"
        };
    }

    get scale() {
        return this.model.scale || 25;
    }

    get style() {
        return this.model.style || "straight";
    }

    get spacing() {
        return (this.model.spacing !== undefined) ? this.model.spacing : 1;
    }

    get wordList() {
        return JSON.parse(this.model.wordcloud);
    }

    set wordList(value) {
        this.model.wordcloud = JSON.stringify(value);
    }

    get usedFontIds() {
        const fontIds = super.usedFontIds;
        // Special case for the "block" font option
        if (!fontIds.includes(this.fontId)) {
            fontIds.push(this.fontId);
        }
        return fontIds;
    }

    refreshElement(transition) {
        this.canvas.refreshElement(this, transition);
    }

    get canRefreshElement() {
        return true;
    }

    get updatesOwnModelAfterResize() {
        return true;
    }

    get fontType() {
        return this.model.font || "block";
    }

    get fontId() {
        return this.fontType === "theme" ? this.styles.fontId : "bebasneue";
    }

    get shouldLoadOpentypeFonts() {
        return true;
    }

    _build() {
        this.needsLayoutMigration = this.model.version == null || this.model.version < 2;
    }

    _calcProps(props, options) {
        const { size } = props;
        const { isTryingLayout } = options;

        // Asked to regen by the editor
        if (this.shouldRegen) {
            this.shouldRegen = false;
            this.canvas.layouter.runPostRender(() => this.generateWordCloud(size, true));
            return { size, isLoading: true };
        }

        // Nothing has changed or trying layout
        if (_.isEqual(this.model.generatedForSize, size.toArray()) || isTryingLayout) {
            return { size, isLoading: false };
        }

        // Something has changed (i.e. layout)
        // Only generate word cloude if we're done resizing
        if (!app.isTrayDragging) {
            const imageLoadedResolver = this.getImageOnLoadPromiseResolver(`size=${size.toString()}`);
            this.canvas.layouter.runPostRender(() => this.generateWordCloud(size, false).then(() => imageLoadedResolver()));
        }
        return { size, isLoading: true };
    }

    renderChildren(transition) {
        let props = this.calculatedProps;
        const { isLoading, bounds } = props;

        if (isLoading) {
            return <Spinner key={this.id} />;
        }

        this.renderedWords = [];
        const children = [];
        const wordList = this.isAnimating ? this.animationWordList : this.wordList;
        for (const word of wordList) {
            const font = this.fonts[this.fontId];
            const fontWeight = word.weight === "5" ? 700 : 400;
            const fontStyle = font.getStyle(fontWeight, false);

            const path = fontStyle.font.getPath(word.word, 0, 0, word.layout.fontSize);

            word.textXOffset = (path.getBoundingBox().x2 - path.getBoundingBox().x1) * -0.5;
            word.textYOffset = path.getBoundingBox().y1 * -0.5;

            const bbox = path.getBoundingBox();
            if (word.layout.rotation) {
                const rotation = word.layout.rotation;

                const center = new geom.Point((bbox.x2 - bbox.x1) / 2 + bbox.x1, (bbox.y2 - bbox.y1) / 2 + bbox.y1);

                path.commands.forEach(command => {
                    if (command.x != undefined) {
                        const point = new geom.Point(command.x, command.y).rotate(rotation, center);
                        command.x = point.x;
                        command.y = point.y;
                    }
                    if (command.x1 != undefined) {
                        const point = new geom.Point(command.x1, command.y1).rotate(rotation, center);
                        command.x1 = point.x;
                        command.y1 = point.y;
                    }
                    if (command.x2 != undefined) {
                        const point = new geom.Point(command.x2, command.y2).rotate(rotation, center);
                        command.x2 = point.x;
                        command.y2 = point.y;
                    }
                });
            }

            let matrix = new SVG.Matrix();
            if (!this.needsLayoutMigration) {
                matrix = matrix.translate(-bounds.width / 2, -bounds.height / 2);
            }
            matrix = matrix.translate(word.layout.x, word.layout.y);
            matrix = matrix.translate(word.textXOffset, word.textYOffset);

            let opacity = 1;
            if (this.isAnimating) {
                const innerWidth = this.innerBounds.width;
                const matrixValues = matrix.extract();
                const isOnLeftSide = (matrixValues.x + (bbox.x2 - bbox.x1) / 2) < innerWidth / 2;
                let progress = Math.clamp((this.animationState.flyInProgress - word.animationDelay) / (1 - word.animationDelay), 0, 1);
                opacity = Math.min(progress * 2, 1);
                progress = 1 - (calcEaseInOut(progress / 2 + 0.5) - 0.5) * 2;

                matrix = matrix.translate(
                    (isOnLeftSide ? -1 : 1) * this.canvas.CANVAS_WIDTH / 2 * progress,
                    0
                );
            }

            const matrixValues = matrix.extract();
            const pathStyles = {
                transform: getCSSTransform({
                    translateX: matrixValues.x,
                    translateY: matrixValues.y
                }),
                fill: this.getWordColor(this.styles, parseInt(word.layout.weight)),
                opacity,
                transition: transition ? "300ms" : "none"
            };

            word.ref = React.createRef();

            this.renderedWords.push(word);

            children.push(<path key={children.length} ref={word.ref} d={path.toPathData()} style={pathStyles} />);
        }

        return <SVGGroup key={this.id}>{children}</SVGGroup>;
    }

    getWordColor(styles, weight) {
        let bgColor = this.getBackgroundColor();

        if (this.canvas.getSlideColor() != ForeColorType.COLORFUL) {
            let baseColor = this.canvas.getTheme().palette.getForeColor(styles.color, this.getSlideColor(), this.getBackgroundColor());

            if (this.model.invertColors) {
                weight = 6 - weight;
            }
            let color;

            switch (this.canvas.getTheme().palette.getBackgroundColorType(bgColor)) {
                case BackgroundStyleType.DARK:
                    color = baseColor.lighten(1.5 * weight * weight);
                    break;
                case BackgroundStyleType.LIGHT:
                    color = baseColor.darken(1 * weight * weight);
                    break;
                case BackgroundStyleType.COLOR:
                    color = baseColor.lighten(1.5 * weight * weight);
                    break;
                default:
                    color = baseColor;
            }

            return color.toHexString();
        } else {
            let colorNames = this.canvas.getTheme().palette.getColorfulColors();

            if (this.model.invertColors) {
                weight = 6 - weight;
            }
            return this.canvas.getTheme().palette.getColor(colorNames[(weight - 1) % colorNames.length]).toHexString();
        }
    }

    /**
     * Makes sure the generation process is single thread and executes only the last request
     * that comes while there's an executing generation request
     */
    async generateWordCloud(size, undo) {
        if (!this.generateWordCloudPromise) {
            this.generateWordCloudPromise = (async () => {
                // Will generate word cloud with current args
                await this._generateWordCloud(size, undo);

                // Will be calling next generation promises until they
                // stop appearing
                while (this.getNextGenerateWordCloudPromise) {
                    // getNextGenerateWordCloudPromise() will remove itself when executed
                    // so we will go to a next cycle run if there was/were new requests
                    // during the execution
                    await this.getNextGenerateWordCloudPromise();
                }

                // Done, remove the promise
                this.generateWordCloudPromise = null;
            })();
        } else {
            // Just overwrite the next generate promise so it'll be executed after the current run
            this.getNextGenerateWordCloudPromise = () => {
                this.getNextGenerateWordCloudPromise = null;
                return this._generateWordCloud(size, undo);
            };
        }

        return this.generateWordCloudPromise;
    }

    async _generateWordCloud(size, undo) {
        const wordList = await this._generateWordList(size);

        // Build our new model from the properties set by the word cloud generator on the wordlist
        this.wordList = wordList.map(({ word, weight, layout, drawn }) => ({
            word,
            weight,
            layout,
            drawn
        }));
        this.model.generatedForSize = size.toArray();
        this.model.version = 2;
        this.needsLayoutMigration = false;

        // Refresh so the new model gets rendered
        this.refreshElement();

        if (!isRenderer) {
            await this.canvas.saveCanvasModel({ undo });
        }
    }

    _generateWordList(size) {
        // Create an off-DOM canvas to render wordcloud to
        const $wordCloud = $.div("wordcloud");
        const $canvas = $wordCloud.addEl($(`<canvas width='${size.width * 2}' height='${size.height * 2}'></canvas>`));

        const hasShape = false;

        // Setup word list
        let wordList;
        switch (this.model.sort || "size") {
            case "size":
                wordList = _.reverse(_.sortBy(this.wordList, o => o.weight));
                break;
            case "random":
                wordList = _.shuffle(this.wordList);
                break;
        }

        // Strip any quotes
        for (const word of wordList) {
            if (word.word.startsWith('"') && word.word.endsWith('"')) {
                word.word = word.word.substr(1, word.word.length - 2);
            }
        }

        // Create options for word cloud generator
        const options = {
            list: wordList,
            weightFactor: this.scale,
            gridSize: this.styles.gridSize || 0,
            shuffle: true,
            drawOutOfBound: true,
            shape: "circle",
            clearCanvas: hasShape ? false : true,
            spacing: this.spacing,
            fontCallback: weight => {
                return `${weight === "5" ? 700 : 400} ${weight * this.scale}px "${this.fontId}"`;
            }
        };

        switch (this.style) {
            case "straight":
                options.rotateRatio = 0;
                break;
            case "right_angles":
                options.rotateRatio = 0.33;
                options.rotationSteps = 2;
                break;
            case "rotated":
                options.rotateRatio = 0.60;
                options.rotationSteps = 6;
                break;
        }

        // Run the word cloud gen
        WordCloud($canvas[0], options);

        return new Promise(resolve => $canvas.on("wordcloudstop", () => resolve(wordList)));
    }

    get animationElementName() {
        return "Word Cloud";
    }

    _getAnimations() {
        return [{
            name: "Word Cloud",
            defaultDuration: 2000,
            prepare: () => {
                this.animationWordList = this.wordList;

                this.animationState.flyInProgress = 0;

                for (const word of this.animationWordList) {
                    word.animationDelay = Math.random() * 0.5;
                }
            },
            onBeforeAnimationFrame: progress => {
                this.animationState.flyInProgress = progress;
            }
        }];
    }
}

export { WordCloudElement };

export const elements = {
    WordCloudElement,
};
